// Espejo del catálogo del backend (API-PROAPP/src/types/EnvioCorreo.ts).
// Texto para un administrador, no para un desarrollador.
export const ETIQUETAS_TIPO = {
  informe_mantencion: 'Informe de mantención',
  comprobante: 'Comprobante de atención',
  incidencia_admin: 'Aviso de incidencia a soporte',
  incidencia_confirmacion: 'Confirmación de incidencia',
  incidencia_respuesta: 'Respuesta de soporte',
  asignacion_solicitud: 'Asignación de solicitud',
  cancelacion_asignacion: 'Cancelación de asignación',
  alerta_regulatoria: 'Alerta de vencimientos',
  reporte_publico: 'Reporte desde código QR',
};

export const ETIQUETAS_ESTADO = {
  pendiente: 'En curso',
  enviado: 'Enviado',
  fallido: 'No llegó',
  omitido: 'No se envió',
};

export const ETIQUETAS_MOTIVO = {
  sin_destinatario: 'El destinatario no tiene correo registrado',
  auto_desactivado: 'El envío automático está desactivado para este cliente',
  entorno_desarrollo: 'Envío suprimido en el entorno de desarrollo',
  revision_pendiente: 'El informe todavía no fue revisado por el supervisor',
};

export const colorEstado = (estado) =>
  ({ enviado: 'green', fallido: 'red', omitido: 'orange', pendiente: 'blue' }[estado] || 'default');

// Traduce el error crudo del servidor de correo (nodemailer/SMTP, en inglés y
// técnico) a una frase entendible para un administrador. El texto original se
// conserva sin cambios y se muestra aparte, plegado, para quien lo necesite.
//
// Un código SMTP (421, 535, 550...) solo cuenta como tal cuando aparece al
// principio del mensaje o de una línea seguido de un espacio, un guion o un
// punto (ej. "421 ", "535-5.7.8"). Buscarlo como sub-cadena suelta hace que
// coincida por casualidad dentro de identificadores de sesión, timestamps o
// IPs (ej. "535a1" dentro de un message-id).
const codigoSmtp = (codigo) => new RegExp(`(^|\\n)${codigo}[ \\-.]`);

// Las categorías específicas van primero: un rechazo de autenticación suele
// venir acompañado del cierre de la conexión, así que si "rechazo temporal"
// se evaluara antes, taparía al fallo de autenticación (que es permanente,
// no algo que se arregla reintentando).
const GRUPOS_ERROR_ENVIO = [
  {
    codigos: ['535'],
    palabras: [/invalid login/, /username and password not accepted/, /authentication/],
    mensaje: 'El sistema no pudo autenticarse ante el servidor de correo.',
  },
  {
    codigos: ['550', '551', '553'],
    palabras: [/recipient/, /does not exist/, /address not found/],
    mensaje: 'La dirección de correo del destinatario no existe o fue rechazada.',
  },
  {
    codigos: ['452'],
    palabras: [/insufficient system storage/, /quota/],
    mensaje: 'El servidor de correo no aceptó el envío por falta de capacidad en ese momento.',
  },
  {
    codigos: [],
    palabras: [/etimedout/, /econnrefused/, /econnreset/, /enotfound/, /timeout/],
    mensaje: 'No se pudo conectar con el servidor de correo.',
  },
  {
    codigos: ['421'],
    palabras: [/try again later/],
    mensaje: 'El servidor de correo rechazó el envío de forma temporal. Se puede reintentar.',
  },
];

const MENSAJE_ERROR_GENERICO = 'El servidor de correo rechazó el envío.';

const coincideGrupo = (texto, { codigos, palabras }) =>
  codigos.some((codigo) => codigoSmtp(codigo).test(texto)) ||
  palabras.some((patron) => patron.test(texto));

export const traducirErrorEnvio = (error) => {
  if (!error) return MENSAJE_ERROR_GENERICO;
  const texto = String(error).toLowerCase();
  const coincidencia = GRUPOS_ERROR_ENVIO.find((grupo) => coincideGrupo(texto, grupo));
  return coincidencia?.mensaje || MENSAJE_ERROR_GENERICO;
};
